/*
  <look-filter> — стрічка сценаріїв над сіткою образів.

  Фільтрація на клієнті: Liquid уже віддав усі картки, ми лише ховаємо зайві.
  Перезавантаження сторінки тут було б повільніше й нічого не додало б —
  Liquid не читає query-параметри, тож серверний фільтр вимагав би окремої
  сторінки на кожен сценарій.

  Стан пишемо в URL, щоб посилання на «Місто» можна було переслати,
  а кнопка «назад» поверталася до попереднього сценарію.
*/
class LookFilter extends HTMLElement {
  connectedCallback() {
    this.rail = this.querySelector('[data-look-rail]');
    this.grid = this.querySelector('[data-look-results]');
    this.chips = Array.from(this.querySelectorAll('[data-look-filter]'));
    this.cells = Array.from(this.querySelectorAll('[data-look-scenario]'));
    if (!this.rail || !this.grid || this.chips.length === 0) return;

    this.param = this.dataset.param || 'scenario';
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.chips.forEach((chip) => {
      chip.addEventListener('click', () => this.apply(chip.dataset.lookFilter, true));
    });

    this.onPop = () => this.apply(this.fromUrl(), false);
    window.addEventListener('popstate', this.onPop);

    this.rail.addEventListener('scroll', () => this.markEdge(), { passive: true });
    this.observer = new ResizeObserver(() => this.markEdge());
    this.observer.observe(this.rail);

    this.apply(this.fromUrl(), false);
  }

  disconnectedCallback() {
    window.removeEventListener('popstate', this.onPop);
    if (this.observer) this.observer.disconnect();
  }

  fromUrl() {
    return new URL(window.location.href).searchParams.get(this.param) || '';
  }

  apply(value, userAction) {
    // Невідомий сценарій в URL не має лишати сітку порожньою
    const chip = this.chips.find((c) => c.dataset.lookFilter === value);
    if (!chip) value = '';

    this.chips.forEach((c) => {
      const on = c.dataset.lookFilter === value;
      c.classList.toggle('is-active', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    this.cells.forEach((cell) => {
      cell.hidden = value !== '' && cell.dataset.lookScenario !== value;
    });

    if (userAction) {
      this.writeUrl(value);
      this.replay();
    } else if (chip && value) {
      this.centerChip(chip);
    }
  }

  writeUrl(value) {
    const url = new URL(window.location.href);
    if (value) {
      url.searchParams.set(this.param, value);
    } else {
      url.searchParams.delete(this.param);
    }
    window.history.pushState({}, '', url);
  }

  /* Активна вкладка може бути за краєм екрана, якщо на сторінку зайшли
     за посиланням. Крутимо саму стрічку, а не сторінку. */
  centerChip(chip) {
    const offset = chip.offsetLeft - (this.rail.clientWidth - chip.clientWidth) / 2;
    this.rail.scrollLeft = Math.max(0, offset);
    this.markEdge();
  }

  markEdge() {
    // Маску-підказку показуємо лише коли стрічка реально не вміщається
    const overflows = this.rail.scrollWidth - this.rail.clientWidth > 1;
    this.toggleAttribute('data-scroller', overflows);
    const end = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 1;
    this.toggleAttribute('data-at-end', end);
  }

  /* Один короткий проявний рух для карток, що лишилися. Перезапускаємо
     анімацію зняттям атрибута + reflow. */
  replay() {
    if (this.reduced) return;
    this.grid.removeAttribute('data-swap');
    void this.grid.offsetWidth;
    this.grid.setAttribute('data-swap', '');
  }
}

if (!customElements.get('look-filter')) {
  customElements.define('look-filter', LookFilter);
}
